<template>
  <div id="app" class="min-w-screen min-h-screen relative flex justify-center sm:pt-16 items-start ">
    <form-widget/>
    <!-- MODAL -->
        <portal-target @change="(newval, oldval) => modal_open = newval" name="form-modal" id="modal-target" :class="{open: modal_open}" class="flex flex-col justify-center items-center absolute top-0 left-0" style="background-color: #0004; width: 100%; min-height: 100%;"></portal-target>
  </div>
</template>

<script>
import {debounce} from 'lodash';
import axios from 'axios';
export default {
    name: 'App',
    data() {
        return {
            modal_open: false,
        };
    },
    components: {
    },
    mounted() {
        //console.log('Apli Url testing:' + process.env.VUE_APP_ROOT_API)
        // Setup GTAG;
        window.dataLayer = window.dataLayer || [];

        this.$store.dispatch('getToken').then(response => {
            this.$store.dispatch('getSuppliers');
            setTimeout(() => {
                this.$store.dispatch('getPaymentTypes');
                 this.$store.dispatch('getDefaultNumberOfDays');
            }, 500);
        });

        setTimeout(() => {
            this.$store.commit('setFormSource', document.querySelector('[data-source-id]').getAttribute('data-source-id') || 'Unknown');
        }, 3000)
    },
    computed: {
        postcode() {
            return this.$store.state.form.post_code;
        },

        payment_type() {
            return this.$store.state.form.payment_type;
        },
        fuel_type() {
            return this.$store.state.form.fuel_type;
        },

        region_id() {
            return this.$store.state.region?.region_id;
        },
        electric_supplier() {
            return this.$store.state.form.electricity_supplier;
        },
        gas_supplier() {
            return this.$store.state.form.gas_supplier;
        },
        dual_supplier() {
            return this.$store.state.form.dual_supplier;
        },

        gas_tariff_details() {
            if (!this.fuel_type) return null;
            if (!this.payment_type) return null;
            if (! (this.gas_supplier)) return null;

            switch (this.fuel_type.value) {
                case 'Gas Only': {
                    return {
                        supplier_id: this.gas_supplier.id,
                        region_id: this.region_id,
                        payment_type: this.payment_type.name
                    }
                }

                case 'Dual': {
                    if (this.$store.state.form.isDualFuel) {
                        return null;
                    }
                    if (!this.gas_supplier ) return {};

                    return {
                        gas_supplier_id: this.gas_supplier.id,
                        region_id: this.region_id,
                        payment_type: this.payment_type.name
                    }

                }
            }
        },
        

        electric_tariff_details() {
            if (!this.fuel_type) return null;
            if (!this.payment_type) return null;
            if (!this.electric_supplier) return null;

            switch (this.fuel_type.value) {
                case 'Electricity Only': {
                    return {
                        electric_supplier_id: this.electric_supplier.id,
                        supplier_id: this.electric_supplier.id,
                        region_id: this.region_id,
                        payment_type: this.payment_type.name
                    }

                }
                case 'Dual': {
                    if (this.$store.state.form.isDualFuel) {
                        return null
                    }
                    if (!this.electric_supplier ) return null;

                    return {
                        electric_supplier_id: this.electric_supplier.id,
                        region_id: this.region_id,
                        payment_type: this.payment_type.name
                    }

                }
            }
        },

        dual_tariff_details() {
            if (!this.fuel_type) return  null;
            if (!this.payment_type) return  null;
            if (!this.dual_supplier) return null;

            switch (this.fuel_type.value) {
                case 'Dual': {
                    if (this.$store.state.form.isDualFuel) {
                        return {
                            supplier_id: this.dual_supplier.id,
                            region_id: this.region_id,
                            payment_type: this.payment_type.name
                        }
                    }

                }
                return null;
            }
        },
    },
    methods: {
        getGasTariffs(details, type) {
            if (!details || !Object.keys(details).length) return;
                
            if (! (details.region_id && (details.supplier_id || details.gas_supplier_id) && details.payment_type)) return;
            this.$store.dispatch('getGasTariffs', {
                ...details, 
                supplier_id: details.supplier_id | details.gas_supplier_id
            });
        },
        getElectricTariffs(details, type) {
            if (!details || !Object.keys(details).length) return;

            if (!(details.region_id && details.electric_supplier_id && details.payment_type)) return;
            this.$store.dispatch('getElectricTariffs', {
                ...details, 
                supplier_id: details.electric_supplier_id
            });       
        },
        getDualTariffs(details, type) {
            if (!details || !Object.keys(details).length) return;
            if (! (details.region_id && details.supplier_id && details.payment_type)) return;
            this.$store.dispatch('getDualTariffs', details);
        },
    },
    watch: {
        postcode: debounce(function(postcode) {
            this.$store.dispatch('getRegion', postcode);
        }, 300),

        'gas_supplier': {
            handler: debounce(function(details) {
                this.getGasTariffs(this.gas_tariff_details, 'gas');
            }, 300),
        },
        'electric_supplier': {
            handler: debounce(function(details) {
                this.getElectricTariffs(this.electric_tariff_details, 'electric');
            }, 300),
        },
        'dual_supplier': {
            handler: debounce(function(details) {
                this.getDualTariffs(this.dual_tariff_details, 'dual');
            }, 300),
        },
    }
}
</script>

<style lang="scss">

#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

* {
  
  font-size: 14px;
  

  input {
      font-size: 16px;
  }

  @screen md {
    font-size: 16px;

  }
}

body {
  font-family: Century Gothic, CenturyGothic, Cantarell, sans-serif;
}

body h1 {
  font-size: 20px;

  @screen md {
    font-size: 22px;
  }
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  border-radius: 3px;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
}



/* When the checkbox is checked, add a blue background */
.cbox-wrapper  .checkmark {
    @apply bg-orange;
//   background-color: #2196F3;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.cbox-wrapper   .checkmark:after  {
  display: block;
}

/* Style the checkmark/indicator */
.cbox-wrapper .checkmark:after {
  left: 9px;
  top: 3px;
  width: 8px;
  height: 16px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.form h1 {
    @apply pb-8 font-semibold mx-4;

}


#modal-target {
    opacity: 0;
    pointer-events: none;

    &.open {
        opacity: 1;
        pointer-events: auto;
    }
}

</style>
